import providers from "@/lib/api";

export default function useTrackContentFeedViews(options?: { onViewRecorded?: (id: string) => void }) {
  const viewedPostIds = new Set<string>();
  const inFlightIds = new Set<string>();

  const trackView = async (id: string | null | undefined) => {
    if (!id || viewedPostIds.has(id) || inFlightIds.has(id)) return;

    viewedPostIds.add(id);
    inFlightIds.add(id);

    try {
      const ok = await providers.ContentSetProvider.updateView({ data: { contentSetIds: [id] } });
      if (ok) {
        options?.onViewRecorded?.(id);
      } else {
        viewedPostIds.delete(id);
      }
    } catch {
      viewedPostIds.delete(id);
    } finally {
      inFlightIds.delete(id);
    }
  };

  return { trackView };
}
